module.exports = __webpack_public_path__ + "static/cross-bronx-poster-e0bab2b1d5329b40d84b1168f817a138.jpg";